var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ar-cta",attrs:{"fab":""},on:{"click":function($event){$event.preventDefault();return _vm.goToAR.apply(null, arguments)}}},[_c('v-icon',{attrs:{"size":24}},[_vm._v("\n        icon-ar\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd5b0c1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/augmentedReality/components/ArButton.vue
// module id = null
// module chunks = 